import { LUMIO_APP_ROUTE_PREFIX } from '@lumio/shared';

const app = (path: string) =>
  `${LUMIO_APP_ROUTE_PREFIX}${path.startsWith('/') ? path : `/${path}`}`;

/** Marketing landing (public). */
export const ROUTE_LANDING = '/';

export const ROUTE_HOME = LUMIO_APP_ROUTE_PREFIX;
export const ROUTE_WELCOME = app('/welcome');
export const ROUTE_LOGIN = app('/login');
export const ROUTE_REGISTER = app('/register');
export const ROUTE_PLANS = app('/plans');
export const ROUTE_PROFILE = app('/profile');
export const ROUTE_AUTH_CREATE_ACCOUNT = app('/auth/create-account');
export const ROUTE_MATCH_DETAILS = app('/match');
export const ROUTE_FORGOT_PASSWORD = app('/forgot-password');
export const ROUTE_RESET_PASSWORD = app('/reset-password');
